module.exports = __webpack_public_path__ + "photo.jpg?740007f750531ce340f3574405994d6f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo.jpg
// module id = 7
// module chunks = 0